import { render, staticRenderFns } from "./ServerGroups.vue?vue&type=template&id=67785757&"
import script from "./ServerGroups.vue?vue&type=script&lang=js&"
export * from "./ServerGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports